import Alpine from 'alpinejs';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';
import Lenis from 'lenis';
import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import { hoverTextModule } from './hoverText';

// CSS
import 'swiper/css';

// Modules
hoverTextModule();

// Register Plugins
gsap.registerPlugin(ScrollTrigger, SplitText);
Swiper.use([Autoplay]);

// Global
window.Alpine = Alpine;
window.Swiper = Swiper;
window.ScrollTrigger = ScrollTrigger;
window.gsap = gsap;

// Inits
Alpine.start();

const lenis = new Lenis({
    autoRaf: true,
    duration: 1.2,
    anchors: true,
    prevent: (node) => node.classList?.contains('js-modal')
});

lenis.on('scroll', () => {
    ScrollTrigger.update();
});